import IContact from "@/module/main/dto/financing-v3/IContact";
import IEmail from "@/module/main/dto/financing-v3/IEmail";
import IPhone from "@/module/main/dto/financing-v3/IPhone";
import ContactType from "@/module/main/dto/financing-v3/ContactTypeEnum";

export class Contact implements IContact
{
    public readonly contactType: ContactType;
    public readonly email?: IEmail;
    public readonly mobile?: IPhone;

    constructor(props: IContact)
    {
        this.contactType = props.contactType;
        this.email = props.email;
        this.mobile = props.mobile;
    }
}
